import initalSlickMovies from './helpers';

(function ($) {
    $(document).ready(() => {

        let $heroSlides = $('section.hero.logged-in');

        if ($heroSlides.length > 0) {
            $heroSlides.slick({
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                arrows: false,
                customPaging : function(slider, i) {
                    return '<div class="dot"><span></span></div>';
                },
            });
        }
    })
})(jQuery)










